<template>
    <div>
         <div v-fancybox>
              <div class="container text-center"
                  style="margin-bottom: 15px; padding: 5px;"
                  v-for="(img,i) in vImages.reverse()"
                  :key="i.url + '_' + i + '_' +new Date().getTime()">
                  <a  :id="img.scrollTo ? 'plotterImageScrollTo' : '#'"/>
                  <div v-if="img.title" class="small" style="margin: 5px;">
                      {{img.title}}
                  </div>

                  <a  class="fancybox"  
                      data-fancybox="gallery"
                      target="_blank" 
                      :href="img.url">
                        <img  class="xslide-content img-fluid rounded"
                              :title="img.title|| '' "
                              :style="img.style"
                              :src="img.url" :alt="img.title"/>
                  </a>
                  <div class="small" style="color: gray;" v-if="images.length > 1">
                    {{img.caption}}
                  </div>
                  <hr>
              </div>
         </div>
    </div>
</template>

<script>
import jQuery from "jquery";
if (window) {
  window.jQuery = jQuery;
  window.$ = jQuery;
}
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox/dist/jquery.fancybox.js";

import Vue from "vue";

import { renderFormula } from "../base/layout-bom";
import {calculateImageStyle} from "../base/utils";

Vue.directive("fancybox", {
  // When the bound element is inserted into the DOM...
  update: function(el) {
    window.el = el;
    Vue.nextTick(() => {
      jQuery(el)
        .find(".fancybox")
        .fancybox();
    });
  }
});

export default {
  props: [
    "images" // [{url, title, ... },...] 
  ],
  computed: {
    vImages() {
      return this.images.map(img => Object.assign({}, img, {style:calculateImageStyle(img)}));
    }
  },
  updated() {
    const that = this;
    this.$nextTick(() => {
      renderFormula(that.$el);
      const target = document.getElementById("plotterImageScrollTo");
      if(target){
        target.scrollIntoView();
        setTimeout(() => target.scrollIntoView(), 1000); // image load time...
      }
    });
  }
};


</script>
 

<style scoped>
</style>
